function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_1075_13088)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M104 -0.00108786L5.09531 -0.000774351C3.81043 -0.0633349 2.55215 0.365295 1.5968 1.19099C0.641458 2.01668 0.0671696 3.17193 0 4.40305V17.5954C0.0671696 18.8265 0.641458 19.9818 1.5968 20.8075C2.55215 21.6332 3.81043 22.0618 5.09531 21.9992H104V-0.00108786Z",
  fill: "url(#paint0_linear_1075_13088)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M93.7171 5.5L95.4427 8.81923L99.2652 9.36948L96.5004 11.9432L97.1498 15.5997L93.7171 13.8779L90.2843 15.5997L90.9337 11.9432L88.1689 9.36948L92.01 8.81923L93.7171 5.5Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M93.7549 11.0025L95.462 8.81923L93.7549 5.5V11.0025Z",
  fill: "url(#paint1_linear_1075_13088)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M93.6802 5.5L91.9731 8.81923L93.6802 11.0025V5.5Z",
  fill: "url(#paint2_linear_1075_13088)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M93.6614 11.02L92.0285 8.78351L88.1875 9.31601L93.6614 11.02Z",
  fill: "url(#paint3_linear_1075_13088)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M88.1689 9.3877L90.9337 11.9614L93.6428 11.0917L88.1689 9.3877Z",
  fill: "url(#paint4_linear_1075_13088)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M93.6623 11.1093L90.9346 11.908L90.2666 15.5645L93.6623 11.1093Z",
  fill: "url(#paint5_linear_1075_13088)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M90.3213 15.6L93.7541 13.8783L93.717 11.1448L90.3213 15.6Z",
  fill: "url(#paint6_linear_1075_13088)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M93.7363 11.1448L93.6807 13.8783L97.1135 15.6L93.7363 11.1448Z",
  fill: "url(#paint7_linear_1075_13088)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M97.1691 15.5645L96.5197 11.908L93.792 11.1093L97.1691 15.5645Z",
  fill: "url(#paint8_linear_1075_13088)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M93.792 11.0739L96.5011 11.9614L99.2659 9.3877L93.792 11.0739Z",
  fill: "url(#paint9_linear_1075_13088)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M99.2474 9.31601L95.4249 8.78351L93.7734 11.02L99.2474 9.31601Z",
  fill: "url(#paint10_linear_1075_13088)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M67.3083 14.6455L64.395 6.32077H66.2506L68.3845 12.7285L70.4998 6.32077H72.3553L69.4236 14.6455H67.3083Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M73.2285 6.32077H74.9356V14.6455H73.2285V6.32077Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M79.8141 6.3212C80.2046 6.31285 80.5928 6.37921 80.9561 6.51638C81.3193 6.65354 81.6503 6.85874 81.9295 7.11994C82.4746 7.65381 82.7798 8.3705 82.7798 9.1168C82.7798 9.86311 82.4746 10.5798 81.9295 11.1137C81.6503 11.3749 81.3193 11.5801 80.9561 11.7172C80.5928 11.8544 80.2046 11.9208 79.8141 11.9124H78.274V14.6459H76.5854V6.3212H79.8141ZM79.8141 10.3859C79.9846 10.3888 80.1538 10.3571 80.3105 10.2928C80.4672 10.2286 80.6079 10.1333 80.7233 10.0132C80.8423 9.89245 80.9348 9.75015 80.9954 9.59467C81.0559 9.4392 81.0833 9.27369 81.0759 9.10793C81.0867 8.77368 80.9601 8.44869 80.7233 8.20269C80.6043 8.08838 80.4625 7.99807 80.3063 7.9371C80.1502 7.87612 79.9828 7.84572 79.8141 7.84769H78.274V10.3859H79.8141Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M56.0569 13.3202H54.5412V7.63871H56.0569C57.7604 7.63871 59.1497 8.68143 59.1497 10.5028C59.2145 12.2106 57.8251 13.3202 56.0569 13.3202ZM56.1216 6.35202H53.4077V14.5568H56.1216C58.5182 14.5568 60.4127 12.9292 60.4127 10.4527C60.4127 7.97626 58.4566 6.35202 56.1216 6.35202Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.68681 14.5568H9.89362C9.89189 14.0947 9.97947 13.6369 10.1513 13.2098C10.3231 12.7826 10.5758 12.3945 10.8948 12.0678C11.2137 11.7411 11.5927 11.4823 12.0097 11.3063C12.4268 11.1303 12.8738 11.0406 13.3249 11.0424H13.651V9.80629H13.3249C12.6783 9.80889 12.0394 9.94923 11.4487 10.2184C10.858 10.4876 10.3284 10.8796 9.89362 11.3697V7.65489H14.1337V6.35202H8.62158L8.68681 14.5568Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.1272 6.35202H14.9375V14.5568H19.7606V13.3202H16.1272V6.35202Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M25.9442 10.5813C25.9481 10.9334 25.8829 11.2827 25.7523 11.6088C25.6217 11.9349 25.4283 12.2311 25.1836 12.4801C24.9388 12.729 24.6477 12.9257 24.3271 13.0586C24.0066 13.1915 23.6633 13.2579 23.3172 13.2538C22.9711 13.2579 22.6277 13.1915 22.3072 13.0586C21.9867 12.9257 21.6955 12.729 21.4508 12.4801C21.206 12.2311 21.0127 11.9349 20.8821 11.6088C20.7515 11.2827 20.6862 10.9334 20.6902 10.5813V10.3208C20.6862 9.96868 20.7515 9.61934 20.8821 9.29328C21.0127 8.96722 21.206 8.67099 21.4508 8.42202C21.6955 8.17305 21.9867 7.97635 22.3072 7.84347C22.6277 7.71059 22.9711 7.64421 23.3172 7.64824C23.6633 7.64421 24.0066 7.71059 24.3271 7.84347C24.6477 7.97635 24.9388 8.17305 25.1836 8.42202C25.4283 8.67099 25.6217 8.96722 25.7523 9.29328C25.8829 9.61934 25.9481 9.96868 25.9442 10.3208V10.5813ZM23.3172 6.35207C22.8039 6.34941 22.2951 6.45036 21.8204 6.64907C21.3457 6.84778 20.9145 7.14031 20.5517 7.50972C20.1889 7.87914 19.9017 8.31809 19.7068 8.80118C19.5118 9.28427 19.413 9.8019 19.4161 10.3241V10.5847C19.413 11.1071 19.5119 11.625 19.7071 12.1084C19.9022 12.5917 20.1897 13.0308 20.5528 13.4002C20.916 13.7697 21.3476 14.0621 21.8227 14.2607C22.2978 14.4592 22.8069 14.5598 23.3205 14.5567C23.834 14.5598 24.3431 14.4592 24.8182 14.2607C25.2933 14.0621 25.7249 13.7697 26.0881 13.4002C26.4512 13.0308 26.7387 12.5917 26.9338 12.1084C27.129 11.625 27.2279 11.1071 27.2248 10.5847V10.3241C27.2104 9.27522 26.7944 8.27343 26.0653 7.53169C25.3362 6.78995 24.3515 6.36676 23.3205 6.35207H23.3172Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M33.9163 6.35202L32.8521 8.76859L33.5342 10.3372L35.2636 6.35202H33.9163Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M37.3268 6.35202L34.5729 12.7988L33.5513 10.3257L32.8964 8.76164L31.8911 6.35202H30.5518L32.212 10.3257L31.1904 12.7988L28.4496 6.35202H27.1104L30.5551 14.5568H31.7601L32.8505 11.9466L33.9344 14.5501H35.146L38.594 6.35202H37.3268Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M41.555 10.9386C40.9719 10.9555 40.3951 11.0691 39.8466 11.2749L41.175 8.13083L42.315 10.9487L41.555 10.9386ZM40.6164 6.35202L37.6575 13.4269C37.5958 13.5581 37.5309 13.7632 37.4692 13.8842L37.2158 14.5568H38.5442L38.9242 13.706C39.2058 13.2207 39.6052 12.8201 40.0827 12.544C40.5602 12.2679 41.0991 12.126 41.646 12.1323H42.9126L43.926 14.5568H45.2544L41.8181 6.35202H40.6164Z",
  fill: "white"
}), /*#__PURE__*/React.createElement("path", {
  d: "M49.3933 11.0277H47.3797V7.70575H49.4096C49.8446 7.71348 50.2598 7.89448 50.5674 8.21059C50.8751 8.52669 51.0513 8.9532 51.0588 9.40017C51.0477 9.84281 50.8661 10.2628 50.5538 10.568C50.2416 10.8732 49.8242 11.0385 49.3933 11.0277ZM52.2592 9.40017C52.2605 9.0149 52.1875 8.63317 52.0446 8.27697C51.9017 7.92077 51.6916 7.59713 51.4265 7.3247C51.1613 7.05227 50.8463 6.83643 50.4996 6.6896C50.1529 6.54278 49.7813 6.46787 49.4063 6.46919H46.1729V14.6739H47.3797V12.3946H49.1558C49.2827 12.5885 50.1057 13.9587 50.6132 14.6739H52.0705C52.0054 14.6104 51.9436 14.5436 51.9436 14.4801L50.4863 12.1406C50.9977 11.8944 51.4336 11.5087 51.7462 11.0254C52.0588 10.5421 52.2363 9.97996 52.2592 9.40017Z",
  fill: "white"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_1075_13088",
  x1: 0,
  y1: 10.9897,
  x2: 109.2,
  y2: 10.9897,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#1D222A"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.39,
  stopColor: "#262D39"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#39435A"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear_1075_13088",
  x1: 93.7549,
  y1: 8.25123,
  x2: 95.462,
  y2: 8.25123,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FDFFF3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.14,
  stopColor: "#FCF7DE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.45,
  stopColor: "#F8E3A6"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.87,
  stopColor: "#F3C34E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F1B932"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear_1075_13088",
  x1: 92.8267,
  y1: 11.0202,
  x2: 92.8267,
  y2: 5.5,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.13,
  stopColor: "#46210E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.18,
  stopColor: "#5F3618"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.42,
  stopColor: "#DCA24E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.59,
  stopColor: "#E5C466"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.74,
  stopColor: "#EBDC77"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.83,
  stopColor: "#EDE57D"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint3_linear_1075_13088",
  x1: 90.9337,
  y1: 10.1857,
  x2: 91.4129,
  y2: 8.61146,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#EDE579"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.06,
  stopColor: "#EBD672"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.14,
  stopColor: "#E6B964"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.34,
  stopColor: "#E2B561"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.54,
  stopColor: "#D8A959"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.75,
  stopColor: "#C6954B"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.95,
  stopColor: "#AD7937"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#A57031"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint4_linear_1075_13088",
  x1: 91.4718,
  y1: 11.8017,
  x2: 90.4268,
  y2: 8.61374,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#46210E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.32,
  stopColor: "#A57031"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.44,
  stopColor: "#B9873C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.72,
  stopColor: "#E6B954"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint5_linear_1075_13088",
  x1: 92.4562,
  y1: 13.9137,
  x2: 90.9285,
  y2: 11.9128,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#A57031"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.01,
  stopColor: "#A77232"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.35,
  stopColor: "#C99844"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.62,
  stopColor: "#DEB050"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.78,
  stopColor: "#E6B954"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint6_linear_1075_13088",
  x1: 94.1994,
  y1: 12.7778,
  x2: 89.8691,
  y2: 14.0684,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.01,
  stopColor: "#A57031"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E6B954"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint7_linear_1075_13088",
  x1: 254.301,
  y1: 40.9502,
  x2: 251.041,
  y2: 46.0131,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.01,
  stopColor: "#A57031"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E6B954"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint8_linear_1075_13088",
  x1: 95.0909,
  y1: 10.914,
  x2: 96.1287,
  y2: 17.9568,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#46210E"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.32,
  stopColor: "#A57031"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.35,
  stopColor: "#AA7534"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.72,
  stopColor: "#DCA24E"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint9_linear_1075_13088",
  x1: 96.4454,
  y1: 10.0444,
  x2: 97.0984,
  y2: 11.7331,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#A57031"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.02,
  stopColor: "#A77232"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.45,
  stopColor: "#C99844"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.79,
  stopColor: "#DEB050"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E6B954"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint10_linear_1075_13088",
  x1: 98.5979,
  y1: 10.949,
  x2: 94.4727,
  y2: 9.28151,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#EEAC1F"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.14,
  stopColor: "#EFB534"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.44,
  stopColor: "#F3CD6C"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.87,
  stopColor: "#F9F3C4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FBFFE1"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_1075_13088"
}, /*#__PURE__*/React.createElement("rect", {
  width: 104,
  height: 22,
  rx: 3,
  fill: "white"
})));

function SvgFlowardVipLgEn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 22,
    viewBox: "0 0 104 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlowardVipLgEn);
export default __webpack_public_path__ + "static/media/floward-vip-lg-en.0ac938b2.svg";
export { ForwardRef as ReactComponent };